module.exports = __webpack_public_path__ + "img/shame.26af5453.jpg";